export default class AdminConsultations {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, {})
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminConsultationRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, payload, {})
  }

  markAsReceived(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/mark-as-received`, {})
  }
  
  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, {})
  }
}
